import { useMemo } from 'react';

import { FieldSuggestionOption } from '../InputGroupWithSuggestions';

// Accepted suggestion is used to determine the UI state of the suggestions indicator in the input field
// It represents whether a suggested value was selected or not
export const useAcceptedSuggestionIndex = (
  localValue: string | null,
  suggestions: FieldSuggestionOption[],
) => {
  return useMemo(
    () => [
      suggestions.findIndex(
        (suggestion) =>
          suggestion.value.toLowerCase().trim() ===
          localValue?.toLowerCase()?.trim(),
      ),
      suggestions.findIndex(
        (suggestion) => suggestion.value.trim() === localValue?.trim(),
      ),
    ],
    [localValue, suggestions],
  );
};
